import React, { useState, useEffect } from 'react';
import AddMunicipio from './AddMunicipio';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
function GestionMunicipios() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [municipios, setMunicipios] = useState([]);
    const [editMunicipio, setEditMunicipio] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [municipioToDelete, setMunicipioToDelete] = useState(null);
    const { user } = useUser();

    const fetchMunicipios = async () => {
        try {
            const response = await fetch(`${server}/MgMunicipios`); // Asegúrate de tener la URL correcta aquí
            const data = await response.json();
            setMunicipios(data.$values);
        } catch (error) {
            console.error('Error al cargar los municipios:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar los municipios: ' + error,
            });
        }
    };

    useEffect(() => {
        fetchMunicipios();
    }, []);

    const handleNewMunicipio = () => {
        fetchMunicipios();
        setEditMunicipio(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleOpenDialog = (municipio) => {
        setMunicipioToDelete(municipio);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setMunicipioToDelete(null);
    };

    const handleDeleteMunicipio = async () => {
        if (municipioToDelete) {
            try {
                const username = ''+user.codigoUsuario+'/';

                const response = await fetch(`${server}/MgMunicipios/${municipioToDelete.idMunicipio}/${username}`, { // Ajusta la URL si es necesario
                    method: 'DELETE'
                });
                if (response.ok) {
                    handleCloseDialog();
                    fetchMunicipios();
                    
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Municipio eliminado con éxito',
                    });
                } else {
                    handleCloseDialog();

                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });

                }
            } catch (error) {
               
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al eliminar el municipio: ' + error,
                });
            }
        }
    };
    const filteredMunicipios = municipios.filter(muni => muni.nombreMunicipio.toLowerCase().includes(searchQuery.toLowerCase()));

  return (
    <>
    <div className="x_title">

    </div>
    <div className="x_content">
        <br />
        <AddMunicipio handleNewMunicipio={handleNewMunicipio} editMunicipio={editMunicipio} />
        <div className="ln_solid" />

        <h2>Municipios Existentes</h2>
        <div className="row">
            <div className="col-md-9 col-sm-4 offset-md-2">
            <TextField
                    variant="outlined"
                    label="Buscar municipio"
                    fullWidth
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{ marginBottom: '20px' }}
                />
                <div className="table-responsive">
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Nombre Municipio</TableCell>
                                <TableCell>Nombre Departamento</TableCell>
                                <TableCell>Nombre País</TableCell>
                                <TableCell>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredMunicipios.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((municipio) => (
                                <TableRow key={municipio.id}>
                                    <TableCell>{municipio.nombreMunicipio}</TableCell>
                                    <TableCell>{municipio.nombreDepartamento}</TableCell>
                                    <TableCell>{municipio.nombrePais}</TableCell>
                                    <TableCell>
                                        <Button onClick={() => setEditMunicipio(municipio)} color="primary" disabled={!tienePermiso('Editar Municipio')}>
                                            Editar
                                        </Button>
                                        <Button onClick={() => handleOpenDialog(municipio)} color="secondary" disabled={!tienePermiso('Eliminar Municipio')}>
                                            Eliminar
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={filteredMunicipios.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
                <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle>{"Confirmar eliminación"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            ¿Estás seguro de que deseas eliminar este municipio?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={handleDeleteMunicipio} color="primary" autoFocus>
                            Eliminar
                        </Button>
                    </DialogActions>
                </Dialog>
                </div>
            </div>
        </div>
    </div>
</>
  )
}

export default GestionMunicipios